import React from "react";
import category_1 from "../../assets/category_1.png";
import category_2 from "../../assets/category_2.png";
import category_3 from "../../assets/category_3.png";
import category_4 from "../../assets/category_4.png";

/**
 * React Component properties
 */
type Props = {
  category: number;
};

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This component is used to display the different categories of the deliveries
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export function DeliveryCategory(props: Props) {
  return (
    <div style={{ width: "100%" }}>
      <h3>Kategorie Ihrer Speditionslieferung: Kategorie {props.category}</h3>

      <div className="delivery_category_container ">
        <div
          className={`delivery_category_element ${
            props.category === 1 && "active"
          }`}
        >
          <div
            className={"image"}
            style={{ background: `url(${category_1})` }}
          />

          <h3>Kategorie 1</h3>
          <p>Stückgüter unter 10 kg. Kann 1 Person alleine bewegen</p>
        </div>

        <div
          className={`delivery_category_element ${
            props.category === 2 && "active"
          }`}
        >
          <div
            className={"image"}
            style={{ background: `url(${category_2})` }}
          />

          <h3>Kategorie 2</h3>
          <p>Stückgüter 10 kg - 30kg. Können 1-2 Personen bewegen</p>
        </div>

        <div
          className={`delivery_category_element ${
            props.category === 3 && "active"
          }`}
        >
          <div
            className={"image"}
            style={{ background: `url(${category_3})` }}
          />

          <h3>Kategorie 3</h3>
          <p>Stückgüter 30 kg - 60 kg. Können 2 Personen bewegen</p>
        </div>

        <div
          className={`delivery_category_element ${
            props.category === 4 && "active"
          }`}
        >
          <div
            className={"image"}
            style={{ background: `url(${category_4})` }}
          />

          <h3>Kategorie 4</h3>
          <p>
            Stückgüter +60kg. Muss von mehr als 2 Personen und einer Tragehilfe
            bewegt werden
          </p>
        </div>
      </div>
    </div>
  );
}
